import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const rorePagesRoutes = [
  {
    path: 'pages',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Pages')
      },
      permissions: ['READ_RORE_PAGES']
    },
    children: [
      {
        path: '',
        name: 'rorePagesList',
        component: wrapLegacyRoute('rorePagesController', 'list')
      },
      {
        path: 'create',
        name: 'rorePageCreate',
        component: wrapLegacyRoute('rorePagesController', 'create')
      },
      {
        path: ':pageId(\\d+)',
        name: 'rorePageDetails',
        component: wrapLegacyRoute('rorePagesController', 'details')
      }
    ]
  }
];

export default rorePagesRoutes;
